import { IFilters } from "@/components/generic/FilterSidbar/GenericFilterSidebar";
import React from "react";
export const CashEquivalentData = [
  {
    title: (
      <>
        <span>Cash Equivalent</span>
      </>
    ),
    eventKey: "casheq-1",
    tabContent: (
      <>
        <p>
          (Clear Cash Balance + Pay-In amount + Notional Cash) - Pay-Out amount
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Clear Cash Balance</span>
      </>
    ),
    eventKey: "casheq-2",
    tabContent: (
      <>
        <p>Cash Available at the beginning of the day</p>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Pay-In Amount</span>
      </>
    ),
    eventKey: "casheq-3",
    tabContent: (
      <>
        <p>
          Funds transferred to your trading account using online funds transfer
          facility
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Notional Cash</span>
      </>
    ),
    eventKey: "casheq-4",
    tabContent: (
      <>
        <p>
          Notional Cash is the limit that will be credited by the next trading
          day and can be used for trading. Notional Cash can be used for placing
          a buy order and not for a Pay-out request
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Pay-Out Amount</span>
      </>
    ),
    eventKey: "casheq-5",
    tabContent: (
      <>
        <p>
          Pay-out is the amount which was utilized for the day. If the bank
          account linked to the trading account that has the NEFT facility
          enabled, then any payout placed before 5 PM will be processed on the
          next trading days. However, kindly note that payout request are
          subject to availability of clear funds in your trading account.
        </p>
      </>
    ),
  },
];
export const Collateral = [
  {
    title: (
      <>
        <span>Collateral</span>
      </>
    ),
    eventKey: "Collateral-1",
    tabContent: (
      <>
        <p>
          Limits provided to you against your holdings after applicable haircut
        </p>
      </>
    ),
  },
];
export const MarginUtilized = [
  {
    title: (
      <>
        <span>Margin utilized</span>
      </>
    ),
    eventKey: "MarginUtilized-1",
    tabContent: (
      <>
        <p>
          Margin amount in the amount utilized by you across all the segments
          day
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Realized MTM</span>
      </>
    ),
    eventKey: "MarginUtilized-2",
    tabContent: (
      <>
        <p>
          Realized MTM is the profit or loss made while squaring off your
          positions
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Unrealized MTM</span>
      </>
    ),
    eventKey: "MarginUtilized-3",
    tabContent: (
      <>
        <p>
          Unrealized MTM is the profit or loss made by your stocks/ contracts
          which are yet to be squared off
        </p>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Initial Margin = Span Margin + Exposure Margin</span>
      </>
    ),
    eventKey: "MarginUtilized-4",
    tabContent: (
      <>
        <p>
          <strong>Span Margin:</strong> it denotes Standardized Portfolio
          Analysis of Risk. This is the system used by the Exchanges for margin
          computation Exposure Margin.
        </p>
        <p>
          <strong>Exposure Margin:</strong> it is the margin amount required by
          Edelweiss on the notional value of positions to be created by the
          Clients and on existing positions based on the prices of the relevant
          contract or underlying which is added to arrive at Initial margin
        </p>
      </>
    ),
  },
];

export const payinMethods = [
  { value: "IB", display: "Net Banking" },
  { value: "UPI", display: "UPI" },
  { value: "QR", display: "UPI via QR code" },
  { value: "INTENT", display: "UPI" },
];

export enum EPaymentType {
  NetBanking = "IB",
  UPI = "UPI",
  UPIviaQR = "QR",
  eCollect = "EC",
  UPIIntent = "INTENT",
}

export const FundTransferFilters: Array<IFilters> = [
  {
    filterName: "Transfer Type",
    eventKey: "requestType",
    list: [
      { title: "Pay-In", key: "payin", selected: false },
      { title: "Pay-Out", key: "payout", selected: false },
    ],
    selectType: "checkbox",
  },
  {
    filterName: "Transfer Status",
    eventKey: "status",
    list: [
      { title: "Success", key: "Success", selected: false },
      { title: "Failed", key: "Failed", selected: false },
      { title: "Pending", key: "Pending", selected: false },
    ],
    selectType: "checkbox",
  },
  {
    filterName: "Payment Mode",
    eventKey: "paymentMode",
    list: [
      { title: "Net Banking", key: "Internet Banking", selected: false },
      { title: "UPI", key: "UPI", selected: false },
    ],
    selectType: "checkbox",
  },
  {
    filterName: "Bank",
    eventKey: "bankAccountNumber",
    list: [
      // { title: "HDFC Bank", key: "HDFC", selected: false },
      // { title: "ICICI Bank ", key: "ICICI", selected: false },
      // { title: "State Bank of India ", key: "State", selected: false },
      // { title: "Bank of Maharashtra ", key: "Maharashtra", selected: false },
    ],
    selectType: "checkbox",
  },
];

export enum EFundRoutes {
  ADD_FUNDS = "add-funds",
  WITHDRAW_FUNDS = "withdraw-funds",
  TRANSFER_HISTORY = "transfer-history",
}
